/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttachmentListResponse } from '../../models/attachment-list-response';

export interface GetContentAttachmentList$Params {

/**
 * ID sekcie
 */
  id: number;
}

export function getContentAttachmentList(http: HttpClient, rootUrl: string, params: GetContentAttachmentList$Params, context?: HttpContext): Observable<StrictHttpResponse<AttachmentListResponse>> {
  const rb = new RequestBuilder(rootUrl, getContentAttachmentList.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AttachmentListResponse>;
    })
  );
}

getContentAttachmentList.PATH = '/client/content/{id}/downloadAttachment';
